let geoCodesTimeout = null;
let inputsTimeout = null;

/**
 * Returns true if the element is visible
 *
 * This code is originally from jQuery and was found at:
 * https://stackoverflow.com/questions/19669786/check-if-element-is-visible-in-dom
 *
 * @param element
 * @return {boolean}
 */
let elementIsVisible = (element) => {
    return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
};

/**
 * setInputGeoCode
 */
let setInputGeoCode = function () {
    let element = jQuery('[name="shipAddress[geoCode]"]');

    if (!Boolean(element.length)) {
        return;
    }

    if (element.val() && element.val() !== '') {
        return;
    }

    element.find('option').each(
        function (index, opt) {
            let option = jQuery(opt);
            if (option.val()) {
                element.val(option.val());
                return false; // break
            }
        }
    );

    element.trigger('change');
};

/**
 * setInputGeoCodesTimed
 */
let setInputGeoCodesTimed = function () {
    if (geoCodesTimeout) {
        clearTimeout(geoCodesTimeout);
    }
    geoCodesTimeout = setTimeout(
        function () {
            geoCodesTimeout = null;
            setInputGeoCode();
        },
        2000
    );
};

/**
 *
 * @param source
 * @param data
 * @param callback
 */
let setInputs = function (source, data, callback) {
    if (data) {

        for (let name in data) {
            let value = data[name];

            let element = jQuery('[name="' + name + '"]');

            if (!element[0]) {
                //element doesn't exist
                continue;
            }

            const plainElement = element[0];
            const tagName = plainElement.tagName;
            const type = plainElement.getAttribute('type');

            if (!elementIsVisible(plainElement)) {
                //Don't fill in hidden elements as doing so can make tests pass that shouldn't pass
                continue;
            }

            if (tagName === 'INPUT' && type === 'checkbox') {
                let boolValue = Boolean(value);
                let checked = element.prop('checked');
                if (boolValue === checked) {
                    continue;
                }
                element.trigger('click');
            } else if (tagName === 'SELECT') {
                for (let i = 0; i < plainElement.children.length; i++) {
                    const plainOptionElement = plainElement.children[i];
                    if (plainOptionElement.innerHTML === value) {
                        jQuery(plainElement).val(plainOptionElement.value).trigger('change');
                        break;
                    }
                }
            } else if (tagName === 'INPUT' && (type === 'text' || type === 'password')) {
                element.val(value).trigger('change');
            }
        }

        setInputGeoCodesTimed();

        callback();
    }
}
    ;

let setInputsFromTestDataService = function (source, testModeService, order, callback) {
    const data = testModeService.getTestData('testAutoFillData', null, { order: order });
    setInputs(source, data, callback);
};

/**
 * Note: The timeout logic in here causes this function to wait longer if it is called
 * multiple times to avoid issues with angular conflicting angular apply() calls
 *
 * @param source
 * @param testModeService
 * @param order
 * @param callback
 */
let setInputsTimed = function (source, testModeService, order, callback) {
    if (inputsTimeout) {
        clearTimeout(inputsTimeout);
    }
    inputsTimeout = setTimeout(
        function () {
            inputsTimeout = null;
            setInputsFromTestDataService(source, testModeService, order, callback);
        },
        2000
    );
};

function angularApplyWhenSafe(scope) {
    const timeout = setTimeout(function () {
        if (!scope.$$phase) {
            scope.$apply();
            clearInterval(timeout);
        }
    }, 100);
}

/**
 *
 */
angular.module('testMode').run(
    [
        '$rootScope',
        'orderMgr',
        'testModeTestAutoFillData',
        'testModeService',
        function (
            $rootScope,
            orderMgr,
            testModeTestAutoFillData,
            testModeService
        ) {
            let events = orderMgr.getEventManager();

            let currentOrder = null;

            let callback = function () {
                angularApplyWhenSafe($rootScope);
            };

            // Might not be needed
            events.on(
                'orderMgr.orderChange',
                function (order) {
                    currentOrder = order;
                    if (testModeService.urlContainsTestModeEnablerParam()) {
                        setInputsTimed('orderMgr.orderChange', testModeService, currentOrder, callback);
                    }
                }
            );

            $rootScope.$on(
                '$viewContentLoaded',
                function () {
                    if (testModeService.urlContainsTestModeEnablerParam()) {
                        setInputsTimed('$viewContentLoaded', testModeService, currentOrder, callback);
                    }
                }
            );

            /**
             * Listen for this event so bookmarklets can trigger it
             */
            document.addEventListener(
                'relivTestModeTestAutoFillInputValuesStart',
                function () {
                    setInputsFromTestDataService(
                        'relivTestModeTestAutoFillInputValuesStart',
                        testModeService,
                        currentOrder,
                        callback
                    );
                }
            );

            if (testModeService.urlContainsTestModeEnablerParam()) {
                setInputsTimed('initialRun', testModeService, currentOrder, callback);
            }
        },
    ]
);
